module.exports = __webpack_public_path__ + "media/PAG65-07.036468be.mp3";